import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import allProducts from "../data/searchproduct";
import { getProductLink } from "../utils/productRoutes";
import "./Header.css";
import logo from "../images/logo.png";
import { FaSearch } from "react-icons/fa";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSearch, setShowSearch] = useState(false);

  const navigate = useNavigate();
  const location = useLocation(); // 🔥 important

  const handleSearch = (e) => {
    e.preventDefault();

    const value = query.trim().toLowerCase();
    if (!value) return;

    // exact match
    const exactMatch = allProducts.find(
      (p) => p.id.toLowerCase() === value
    );

    if (exactMatch) {
      navigate(getProductLink(exactMatch));
      setQuery("");
      setMenuOpen(false);
      setSuggestions([]);
      return;
    }

    // search page
    navigate(`/search?q=${encodeURIComponent(value)}`);
    setQuery("");
    setMenuOpen(false);
    setSuggestions([]);
  };

  return (
    <header className="header">
      <div className="header-inner">

        {/* Logo */}
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>

        {/* Navigation */}
        <nav className={`nav ${menuOpen ? "open" : ""}`}>

          <Link
            to="/"
            className={location.pathname === "/" ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>

          <Link
            to="/about"
            className={location.pathname === "/about" ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            About Us
          </Link>

          <Link
            to="/products"
            className={location.pathname.includes("/products") ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            Products
          </Link>

          <Link
            to="/contact"
            className={location.pathname === "/contact" ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            Contact Us
          </Link>

        </nav>

        {/* Search */}
        <div className={`search-container ${showSearch ? "active" : ""}`}>
          {!showSearch ? (
            <button
              className="search-icon-btn"
              onClick={() => setShowSearch(true)}
            >
              <FaSearch />
            </button>
          ) : (
            <form className="search-box" onSubmit={handleSearch}>
              <input
                type="text"
                autoFocus
                placeholder="Search..."
                value={query}
                onChange={(e) => {
                  const value = e.target.value;
                  setQuery(value);

                  if (value.trim() === "") {
                    setSuggestions([]);
                    return;
                  }

                  const filtered = allProducts
                    .filter(
                      (p) =>
                        p.id.toLowerCase().startsWith(value.toLowerCase()) ||
                        p.name.toLowerCase().includes(value.toLowerCase())
                    )
                    .slice(0, 6);

                  setSuggestions(filtered);
                }}
              />

              {/* Close */}
              <span
                className="close-search"
                onClick={() => {
                  setShowSearch(false);
                  setQuery("");
                  setSuggestions([]);
                }}
              >
                ✖
              </span>

              {/* Suggestions */}
              {suggestions.length > 0 && (
                <div className="search-dropdown">
                  {suggestions.map((item) => (
                    <div
                      key={item.id}
                      className="search-item"
                      onClick={() => {
                        navigate(getProductLink(item));
                        setQuery("");
                        setSuggestions([]);
                        setShowSearch(false);
                      }}
                    >
                      <span className="search-item-image">
                        <img src={item.image} alt={item.name} />
                      </span>
                      <span className="search-item-text">
                        <span className="search-item-name">{item.name}</span>
                        <span className="search-item-code">{item.id}</span>
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </form>
          )}
        </div>

        {/* Hamburger */}
        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

      </div>
    </header>
  );
};

export default Header;
